<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg-icon class-name="international-icon" icon-class="language" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='zh'" command="zh">
        中文
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='en'" command="en">
        English
      </el-dropdown-item>
      <!-- <el-dropdown-item :disabled="language==='es'" command="es">
        Español
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='ja'" command="ja">
        日本語
      </el-dropdown-item> -->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { getPermission } from '@/api/users'
import { getToken, setAllPermission, setTopNavs, getDefaultCur } from '@/utils/auth'
export default {
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      // 重新获取路由数据并刷新
      if (getToken()) {
        getPermission({}).then(res => {
          const myPermission = [] // 顶层分类循环
          let navList = [] // 设置头部导航
          let defaultCur = getDefaultCur()
          res.data.forEach((item, index) => {
            myPermission[index] = {
              alias: item.alias,
              name: item.name,
              id: item.id,
              router: item.child
            }
            navList[index] = {
              alias: item.alias,
              current: index == defaultCur,
              name: item.name
            }
          })
          setAllPermission(myPermission)
          setTopNavs(navList)
          location.reload()
        })
      }
      // this.$message({
      //   message: 'Switch Language Success',
      //   type: 'success'
      // })
    }
  }
}
</script>
